import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function ScheduleTasksSkeleton({ isDarkMode }) {
    const cardCls = `rounded-xl border shadow-sm ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const bannerCls = "rounded-xl px-6 py-6 bg-primary-900/90";
    const tileCls = "bg-primary-800/40 rounded-xl px-4 py-5";
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";
    const bannerBaseColor = "rgba(255,255,255,0.16)";
    const bannerHighlightColor = "rgba(255,255,255,0.3)";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <section className="max-w-6xl mx-auto px-4 py-6 md:py-8">
                    {/* Header + Add Task button */}
                    <header className="flex items-start md:items-center justify-between gap-4 mb-6">
                        <div className="min-w-0">
                            <Skeleton width={220} height={30} className="mb-2" />
                            <Skeleton width={320} height={18} />
                        </div>
                        <Skeleton width={110} height={40} borderRadius={8} />
                    </header>

                    {/* Focus-area filter tabs */}
                    <div className="flex flex-wrap items-center gap-2 mb-6">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <Skeleton key={i} width={90} height={32} borderRadius={999} />
                        ))}
                    </div>
                </section>

                <main className="max-w-6xl mx-auto px-4 pb-8">
                    {/* Calendar */}
                    <section className="mb-6">
                        <div className={`${cardCls} p-6`}>
                            <div className="flex items-center justify-between mb-6">
                                <div className="flex gap-2">
                                    <Skeleton width={32} height={32} borderRadius={8} />
                                    <Skeleton width={32} height={32} borderRadius={8} />
                                    <Skeleton width={70} height={32} borderRadius={8} />
                                </div>
                                <Skeleton width={180} height={26} />
                                <div className="flex gap-1">
                                    <Skeleton width={60} height={32} borderRadius={8} />
                                    <Skeleton width={60} height={32} borderRadius={8} />
                                    <Skeleton width={60} height={32} borderRadius={8} />
                                </div>
                            </div>
                            <Skeleton height={420} borderRadius={8} />
                        </div>
                    </section>

                    {/* Weekly Overview banner */}
                    <SkeletonTheme baseColor={bannerBaseColor} highlightColor={bannerHighlightColor}>
                        <section className="mb-6">
                            <div className={bannerCls}>
                                <Skeleton width={140} height={18} className="mb-4" />
                                <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
                                    {Array.from({ length: 4 }).map((_, i) => (
                                        <div key={i} className={tileCls}>
                                            <Skeleton width={100} height={12} />
                                            <Skeleton width={50} height={26} className="mt-2" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>
                    </SkeletonTheme>

                    {/* Legend */}
                    <section>
                        <div className={`${cardCls} p-4`}>
                            <Skeleton width={90} height={16} className="mb-3" />
                            <div className="flex flex-wrap items-center gap-4">
                                {Array.from({ length: 5 }).map((_, i) => (
                                    <Skeleton key={i} width={110} height={16} />
                                ))}
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </SkeletonTheme>
    );
}
